/**
 * Sanitize a URL for use in an `<a href>`. Model/RAG output and user-submitted
 * links can contain `javascript:`, `data:`, etc.; React does NOT sanitize the
 * href scheme, so a click would execute in Sally's origin. Returns the URL only
 * when it's a plain http(s) link, otherwise `undefined` (React then omits the
 * href → the anchor is inert, not a script trigger).
 */
export function safeHref(raw: unknown): string | undefined {
  if (typeof raw !== "string" || !raw) return undefined;
  try {
    const u = new URL(raw, window.location.origin);
    return u.protocol === "https:" || u.protocol === "http:" ? u.href : undefined;
  } catch {
    return undefined;
  }
}
